var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialog",
      staticClass: "approval-file-dialog",
      class: { "preview-maximized": _vm.maximized },
      attrs: {
        title: _vm.file.name,
        visible: true,
        "append-to-body": "",
        width: "90%",
        top: "3vh",
      },
      on: {
        close: function ($event) {
          return _vm.$emit("close")
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "attachment-titlebar",
          attrs: { slot: "title" },
          on: {
            mousedown: _vm.startMove,
            dblclick: function ($event) {
              _vm.maximized = !_vm.maximized
            },
          },
          slot: "title",
        },
        [
          _c("strong", { staticClass: "el-dialog__title" }, [
            _vm._v(_vm._s(_vm.file.name)),
          ]),
          _c(
            "button",
            {
              attrs: { type: "button" },
              on: {
                mousedown: function ($event) {
                  $event.stopPropagation()
                },
                dblclick: function ($event) {
                  $event.stopPropagation()
                },
                click: function ($event) {
                  _vm.maximized = !_vm.maximized
                },
              },
            },
            [_vm._v(_vm._s(_vm.maximized ? "还原窗口" : "最大化窗口"))]
          ),
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading",
            },
          ],
          staticClass: "approval-file-viewer",
          attrs: {
            "data-preview-state": _vm.rendered ? "rendered" : "loading",
          },
        },
        [
          _vm.error
            ? _c("el-alert", {
                attrs: { title: _vm.error, type: "warning", closable: false },
              })
            : _vm._e(),
          _vm.slides
            ? _c("slide-pages", { attrs: { transport: _vm.slides } })
            : _vm.media === "image"
            ? _c("interactive-image", {
                attrs: { src: _vm.file.url, name: _vm.file.name },
                on: {
                  load: function ($event) {
                    _vm.rendered = true
                  },
                  error: function ($event) {
                    _vm.error = "图片加载失败，可下载原文件查看"
                  },
                },
              })
            : _vm.media === "video"
            ? _c("video", { attrs: { src: _vm.file.url, controls: "" } })
            : _vm.media === "audio"
            ? _c("audio", { attrs: { src: _vm.file.url, controls: "" } })
            : _vm.legacyHTML
            ? _c("iframe", {
                attrs: {
                  srcdoc: _vm.legacyHTML,
                  sandbox: "",
                  referrerpolicy: "no-referrer",
                  title: "旧版审批附件预览",
                },
                on: {
                  load: function ($event) {
                    _vm.rendered = true
                  },
                },
              })
            : _vm.html
            ? _c("iframe", {
                ref: "frame",
                attrs: {
                  srcdoc: _vm.html,
                  sandbox: "allow-scripts",
                  referrerpolicy: "no-referrer",
                  title: "审批附件预览",
                },
              })
            : _vm.text !== null
            ? _c("pre", [_vm._v(_vm._s(_vm.text))])
            : !_vm.loading && !_vm.error
            ? _c("p", [
                _vm._v(
                  "此格式暂不支持在线预览，可下载原文件后使用对应软件打开。"
                ),
              ])
            : _vm._e(),
        ],
        1
      ),
      _c(
        "span",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "el-button",
            {
              on: {
                click: function ($event) {
                  return _vm.$emit("close")
                },
              },
            },
            [_vm._v("关闭")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", loading: _vm.downloading },
              on: { click: _vm.download },
            },
            [_vm._v("下载原文件")]
          ),
        ],
        1
      ),
      _vm.moving
        ? _c("div", { staticClass: "attachment-drag-shield" })
        : _vm._e(),
      _vm.picture
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.picture.name,
                visible: true,
                "append-to-body": "",
                width: "85%",
              },
              on: {
                close: function ($event) {
                  _vm.picture = null
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { height: "75vh" } },
                [
                  _c("interactive-image", {
                    attrs: { src: _vm.picture.data, name: _vm.picture.name },
                  }),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }